export default __webpack_public_path__ + "static/media/Wellingtons-Medium.1b5c53d6.woff2";